import axios from "axios";

export default axios.create({
  baseURL:
    "https://us-central1-xtrimpro-refiereygana.cloudfunctions.net/consultasV2/api/v1/",
  // "https://us-central1-xtrimpro-refiereygana.cloudfunctions.net/consultas/api/v1/",
  // "https://us-central1-xtrim-referidos.cloudfunctions.net/consultas/api/v1/",
});
